module.exports = __webpack_public_path__ + "fonts/rubik-medium-webfont.b800b1b5.b800b1b5.woff2";